import globals from '../../../components/common/globals';
import vxMysteryHeader from '../vx-mystery-header/vx-mystery-header.vue';
import vxMysteryFooter from '../vx-mystery-footer/vx-mystery-footer.vue';
import vxMysteryReferralMixin from './vx-mystery-referral-mixin';
import vxModal from '../../../components/common/vx-modal/vx-modal.vue';

export default {
  name: 'vx-mystery-referral',
  components: { vxMysteryHeader, vxMysteryFooter, vxModal },
  data() {
    return {
      globals,
      title: 'Referral page',
      submitButtonText: 'SUBMIT',
      popupSubmitButtonText: 'Click Here',
      formErrors: '',
      refErrorCount: 0,
      mysCpuserId: '',
      mysEmailId: '',
      mysQplsCouponId: '',
      mysQplsUniqId: '',
    };
  },
  mounted() {
    if (!this.globals.getCookie('mys_cpuserid')) {
      window.location.href = '/mystery-coupon/opt-in';
    } else {
      this.mysCpuserId = this.globals.getCookie('mys_cpuserid');
    }

    if (!this.globals.getCookie('mys_qples_couponids') || !this.globals.getCookie('mys_qples_uniqueid')) {
      this.qplesErrorMsg();
    } else {
      if (this.globals.getCookie('mys_qples_couponids')) {
        this.mysQplsCouponId = this.globals.getCookie('mys_qples_couponids');
      }
      if (this.globals.getCookie('mys_qples_uniqueid')) {
        this.mysQplsUniqId = this.globals.getCookie('mys_qples_uniqueid');
      }
    }


    if (this.globals.getCookie('mys_email')) {
      this.mysEmailId = this.globals.getCookie('mys_email');
    }
  },
  mixins: [vxMysteryReferralMixin],
  methods: {
    submitResetField(e) {
      this.RestGPsubmitForm(e);
    },
    qplesErrorMsg() {
      this.$refs.viewQplesErrModal.open();
    },
    referralSubmit(e) {
      e.preventDefault();
      if (!this.refErrorCount) {
        this.GPsubmitForm(e);
      }
    },
    checkValidate(e) {
      const el = e.target ? e.target : e;
      const out = [];
      let emailErrCount = 0;
      let fnameErrCount = 0;

      if (el.value) {
        if (el.name.indexOf('first_name_friend') != -1) {
          const emailName = `email_friend${el.name.slice(-1)}`;
          this.$el.querySelector(`[name=${emailName}]`).setAttribute('validation', 'required email');
          if (!this.$el.querySelector(`[name=${emailName}]`).value && !emailErrCount) {
            out.push('“You must supply your friend’s email, otherwise we can’t send them an email” – Friend Email Required');
            this.refErrorCount = 1;
            emailErrCount = 1;
          } else if (this.$el.querySelector('[name=consumer_first_name]').value && this.$el.querySelector('[name=consumer_last_name]').value) {
            this.refErrorCount = 0;
            emailErrCount = 0;
          }
        }

        if (el.name.indexOf('email_friend') != -1) {
          const fName = `first_name_friend${el.name.slice(-1)}`;
          this.$el.querySelector(`[name=${fName}]`).setAttribute('validation', 'required');
          if (!this.$el.querySelector(`[name=${fName}]`).value && !fnameErrCount) {
            out.push('“You must supply your friend’s name if you’re providing their email address” – Friend Name Required');
            this.refErrorCount = 1;
            fnameErrCount = 1;
          } else if (this.$el.querySelector('[name=consumer_first_name]').value && this.$el.querySelector('[name=consumer_last_name]').value) {
            this.refErrorCount = 0;
            fnameErrCount = 0;
          }
        }

        if (el.name === 'consumer_first_name' || el.name === 'consumer_last_name' || this.refErrorCount) {
          this.$el.querySelector('[name=consumer_first_name]').setAttribute('validation', 'required');
          this.$el.querySelector('[name=consumer_last_name]').setAttribute('validation', 'required');
          this.$el.querySelector('[name=email_friend1]').setAttribute('validation', 'required email');
          if (!this.$el.querySelector('[name=consumer_first_name]').value || !this.$el.querySelector('[name=consumer_last_name]').value) {
            out.push('“You must supply Your First and Last Name if you’d like to refer a friend” – Consumer’s First or Last Name is missing');
            this.refErrorCount = 1;
          } else if (!this.$el.querySelector('[name=email_friend1]').value && !emailErrCount) {
            out.push('“You must supply your friend’s email, otherwise we can’t send them an email” – Friend Email Required');
            this.refErrorCount = 1;
          } else {
            this.refErrorCount = 0;
          }
        }

        const result = [];
        for (let i = 0; i < out.length; i++) {
          if (out[i].length) { result.push(out[i]); }
        }
        this.formErrors = result.join('<br/>');
      }
    },
  },
};




// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-referral/vx-mystery-referral.js